import { Box, Paper } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getAllSelfAppraisalAssignedLists } from "../../../redux/features/appraisalSlice";
import GlobalDatagrid from "../../../components/mui/DataGrid/GlobalDatagrid";
import { selfAppraisalTableHeader } from "../../../components/datagrid/appraisal/selfAppraisalTableHeader";

export const SelfAppraisalLanding = () => {
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, search, rowData } = paginationData;
  const { loading, selfAppraisalDatas } = useSelector(
    (state) => state.appraisal
  );
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const dispatchParams = {
    paginationData,
    search,
  };
  useEffect(() => {
    if (pageNum && gridSize) {
      dispatch(getAllSelfAppraisalAssignedLists(dispatchParams));
    }
  }, [gridSize, pageNum, search]);
  return (
    <Box mt={0.5}> 
      <Paper>
        <GlobalDatagrid
          tableHead={selfAppraisalTableHeader(getAllSelfAppraisalAssignedLists,dispatchParams)}
          rows={selfAppraisalDatas?.data}
          meta={selfAppraisalDatas?.meta?.totalRecords}
          rowUniqueId="sl_no"
          loading={loading}
          rowClick={false}
        />
      </Paper>
    </Box>
  );
};
